import React, { useState, useEffect } from 'react';
import RecommendedHomesStyles from './RecommendedHomes.styled';
import ItemsGridSwiper from '../../components/ItemsGridSwiper/ItemsGridSwiper';
import { ItemsGrid } from 'dx-sdk/build/components';

export const RecommendedHomes = ({
  listItems,
  heading,
  subHeading,
  swiperID,
  dealer,
  homes,
  retailEventLabel,
}) => {
  return (
    <RecommendedHomesStyles>
      <div className="grid-container">
        <ItemsGrid
          heading={heading ? heading : 'Recommended Homes'}
          subheading={subHeading}
          componentsProps={{
            Heading: {
              variant: 'h2',
              component: 'p',
            },
            SubHeading: {
              variant: 'caption',
              component: 'p',
            },
          }}
        >
          {listItems && listItems !== null && listItems.length > 0 && (
            <ItemsGridSwiper
              swiperID={swiperID ? swiperID : 'default-swiper'}
              listItems={listItems}
              dealer={dealer}
              homes={homes}
              retailEventLabel={retailEventLabel}
            />
          )}
        </ItemsGrid>
      </div>
    </RecommendedHomesStyles>
  );
};

export default RecommendedHomes;
